import {WithNextSlot} from "@components/Booking/useNextAvailable";
import {Location} from "@components/Booking/LocationSelection/types";
import {Image} from "./Image";
import {LocationInfo} from "./LocationInfo";
import {SelectButton} from "./SelectButton";
import React from "react";
import {WithDistance} from "@components/Booking/LocationSelection/useWithDistanceFromUser";

const LocationRowContents = ({
  disabled,
  location,
  slotsLoading,
}: {
  disabled: boolean;
  location?: WithDistance<WithNextSlot<Location>>;
  slotsLoading: boolean;
}) => {
  const locationName = location?.name;
  const imgId = location?.images?.nodes?.[0]?.image?.id;
  return (
    <>
      {imgId && locationName && <Image imgId={imgId} locationName={locationName} />}
      {location && (
        <LocationInfo disabled={disabled} location={location} slotsLoading={slotsLoading} />
      )}
      {!disabled && <SelectButton />}
    </>
  );
};

export default React.memo(LocationRowContents);
